<template>
    <div class="flex">
        <router-link class="flex items-center gap-0.5" :to="{ name: 'tasks' }">
            <svg
                class="w-14"
                viewBox="0 0 256 256"
            >
                <g transform="matrix(2.93164,0,0,2.93164,30.5108,1.53029)">
                    <g transform="matrix(4.16667,0,0,4.16667,36.5017,35.435)">
                        <path d="M0,0.919L-0.001,-0.001L-0.797,-0.459L-1.59,0L-1.591,0.92L-0.794,1.378L0,0.919Z" :fill="color" />
                    </g>
                    <g transform="matrix(4.16667,0,0,4.16667,7.0375,32.7292)">
                        <path d="M0,4.997L0.007,-2.279L6.277,-5.903L12.571,-2.285L12.581,4.992L7.171,8.119L7.171,3.174L6.299,3.677L5.424,3.173L5.419,8.116L0,4.997ZM14.273,5.967L14.26,-3.264L6.275,-7.855L-1.68,-3.257L-1.689,5.974L5.417,10.065L5.414,12.852L7.171,12.852L7.171,10.073L14.273,5.967Z" :fill="color" />
                    </g>
                </g>
            </svg>
            <div>
                <h5 class="!text-3xl !leading-none logo pt-1" :style="{ 'color': color }">
                    IMPRION
                </h5>
                <h5 class="!text-sm font-light !leading-none logo" :style="{ 'color': color }">
                    WORK LOG
                </h5>
            </div>
        </router-link>
    </div>
</template>
<script lang="ts" setup>
    defineProps({
        title: {
            type: Boolean,
            default: false
        },
        color: {
            type: String,
            default: '#FFFFFF'
        }
    })
</script>

<style scoped>
.logo {
  font-family: Montserrat,Helvetica,Arial,serif;
}
</style>
